import React, { useState } from 'react'
import ArrowIcon from '../../elements/icons/ArrowIcon'
import TrashIcon from '../../elements/icons/TrashIcon'
import ModalDialog from '../../layouts/ModalDialog'
import EditInventoryLocation from './EditInventoryLocation'

const InventoryLocationCard = ({location}) => {
    const [editingLocation, setEditingLocation] = useState(false)
    return (
        <>
            <div className='bg-full bg-white rounded-[8px] p-[20px] bg-opacity-60 border border-gray-200'>
                <h3 className='font-[500] text-[15px] mb-1'>{location.name}</h3>
                <p className='text-gray-500 text-[13px]'>{location.description.slice(0, 120)}{location.description.length > 120 ? '...' : ''}</p>

                <p className='text-xs mt-2 mb-1 font-[600] text-gray-600'>Approvers</p>
                <p className='text-gray-800 text-[13px]'>{location.approvers.slice(0, 2).map(appr => appr.fullName).join(', ')}{location.approvers.length > 2 ? `, ${location.approvers.length - 2} more` : ''}</p>
                
                <div className='pt-[20px] mt-[10px] border-t border-gray-300 flex items-center justify-between'>
                    <button onClick={()=>{setEditingLocation(true)}} className='flex items-center gap-x-[5px] font-medium font-space-grotesk text-xs'>
                        View/Edit location
                        <ArrowIcon className={`w-4 h-4`} />
                    </button>

                    <button className='p-1 rounded transition duration-200 hover:bg-gray-100 text-gray-500 hover:text-red-500'>
                        <TrashIcon className={`w-4 h-4`} />
                    </button>
                </div>
            </div>

            <ModalDialog
                shown={editingLocation} 
                closeFunction={()=>{setEditingLocation(false)}} 
                actionFunction={()=>{}} 
                actionFunctionLabel={``}
                dialogTitle='View/Edit Inventory Location'
                maxWidthClass='max-w-lg'
                hideActions={true}
            >
                <EditInventoryLocation 
                    location={location}
                    close={()=>{setEditingLocation(false)}} 
                />

            </ModalDialog>
        </>
    )
}

export default InventoryLocationCard